import React from 'react';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()({
  slide: {
    height: '100%',
  },
});

const Slide: React.FC = ({ children }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.slide} data-test-locator="gallery-slide">
      {children}
    </div>
  );
};

export { Slide };
